import { Instagram, Facebook, MessageSquareText, Mail } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const anchors = [
  { label: "Services", id: "services", testid: "footer-link-services" },
  { label: "Membership", id: "membership", testid: "footer-link-membership" },
  { label: "Results", id: "results", testid: "footer-link-results" },
  { label: "Request Service", id: "request", testid: "footer-link-request" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-graphite bg-ink pt-20 pb-10 px-5 sm:px-8">
    <div className="max-w-7xl mx-auto">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <img
            src="/assets/dark-wordmark.png"
            alt="DARK Mobile Detail wordmark"
            className="h-16 w-auto mix-blend-screen"
            loading="lazy"
            data-testid="footer-wordmark"
          />
          <p className="font-display italic text-silver/70 mt-5">Vehicle care for people with a standard.</p>
        </div>
        <div>
          <p className="font-accent text-[10px] tracking-[0.3em] uppercase text-volt mb-5">Service Area</p>
          <p className="text-silver/70 text-sm leading-relaxed" data-testid="footer-service-area">
            Kansas City Metro — Kansas &amp; Missouri, including Kansas City KS, Kansas City MO, Overland Park,
            Shawnee, Lenexa, Olathe, Independence, and nearby areas within service range.
          </p>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 mt-7" aria-label="Footer">
            {anchors.map((a) => (
              <button
                key={a.id}
                data-testid={a.testid}
                onClick={() => scrollToId(a.id)}
                className="font-accent text-[10px] tracking-[0.25em] uppercase text-silver/50 hover:text-ivory transition-colors duration-300"
              >
                {a.label}
              </button>
            ))}
          </nav>
        </div>
        <div>
          <p className="font-accent text-[10px] tracking-[0.3em] uppercase text-volt mb-5">Contact</p>
          <div className="space-y-3 text-sm text-silver/70">
            <a data-testid="footer-text-link" href="sms:+19133885449" className="flex items-center gap-3 hover:text-ivory transition-colors duration-300">
              <MessageSquareText className="w-4 h-4 text-volt" /> (913) 388-5449
            </a>
            <a data-testid="footer-email-link" href="mailto:dartgt9302@gmail.com" className="flex items-center gap-3 hover:text-ivory transition-colors duration-300">
              <Mail className="w-4 h-4 text-volt" /> dartgt9302@gmail.com
            </a>
            <p className="flex items-center gap-3 text-silver/70">
              <span className="w-4 h-4 text-volt font-accent text-[10px] tracking-widest">W</span> darkmobiledetail.com
            </p>
          </div>
          <div className="flex gap-4 mt-7">
            <a data-testid="footer-social-instagram" href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"
               className="w-10 h-10 border border-graphite flex items-center justify-center text-silver/60 hover:text-volt hover:border-volt transition-colors duration-300">
              <Instagram className="w-4 h-4" />
            </a>
            <a data-testid="footer-social-facebook" href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"
               className="w-10 h-10 border border-graphite flex items-center justify-center text-silver/60 hover:text-volt hover:border-volt transition-colors duration-300">
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-graphite/60 mt-16 pt-7 flex flex-col sm:flex-row justify-between gap-3">
        <p className="font-accent text-[10px] tracking-[0.25em] uppercase text-silver/40">
          © {new Date().getFullYear()} DARK Mobile Detail
        </p>
        <p className="font-accent text-[10px] tracking-[0.25em] uppercase text-silver/40">
          Less noise. More presence.
        </p>
      </div>
    </div>
  </footer>
);
